<div
  class="configurator-drawer"
  [ngClass]="{ open: globalStateProviderService.drawerOpen }"
>
  <div class="drawer-header">
    <div class="title-bar">
      <h1 i18n="@@Configuration">Configuration</h1>
      <div class="drawer-header-buttons">
        <button
          name="toggle-advanced"
          class="advanced-toggle"
          (click)="toggleAdvanced()"
          [ngClass]="{ active: advancedFlag }"
          placement="left"
          container="body"
          i18n-tooltip="@@Advanced mode"
          tooltip="Advanced mode"
        >
          <i class="fal fa-cog"></i>
        </button>
        <button
          name="close-drawer"
          class="drawer-close"
          (click)="globalStateProviderService.drawerOpen = false"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <nav class="drawer-tabs">
      <ul>
        <li
          i18n="@@System"
          [ngClass]="{ active: activeTab === 'system' }"
          (click)="toggleTab('system')"
        >
          System
        </li>
        <li
          i18n="@@Forms"
          [ngClass]="{ active: activeTab === 'forms' }"
          (click)="toggleTab('forms')"
          [hidden]="!routeVisibilityMap.forms"
        >
          Forms
        </li>
      </ul>
    </nav>
  </div>
  <div class="drawer-body">
    <section class="system" [ngClass]="{ active: activeTab === 'system' }">
      <div class="search-field-container configurator-field">
        <label for="configuration-filter-system"
          ><i class="far fa-magnifying-glass"></i
        ></label>
        <input
          type="text"
          [(ngModel)]="searchTermText"
          (ngModelChange)="onChangeSearchTerm()"
          id="configuration-filter-system"
          name="configuration-filter"
          class="configuration-filter"
          i18n-placeholder="@@Search..."
          placeholder="Search..."
        />
      </div>

      <div class="properties-container">
        <!-- General -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.system?.general"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
              (keydown.enter)="toggleClass($event, 'section-open')"
              (keydown.space)="toggleClass($event, 'section-open')"
              tabindex="0"
            >
              <span i18n="@@General">General</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 7"
            [hidden]="!searchResultMap.system?.general?.subsection1"
          >
            <div
              class="cols"
              [hidden]="!searchResultMap.system?.general?.subsection1?.column1"
            >
              <!-- Primary color -->
              <div
                [hidden]="
                  !searchResultMap.system?.general?.subsection1?.column1
                    ?.primaryColor
                "
              >
                <p i18n="@@Primary color" class="drawer-label">Primary color</p>
                <ul class="colors-list">
                  <li
                    data-hue="210"
                    data-saturation="42"
                    data-lightness="47"
                    style="
                      --bg-hue: 210;
                      --bg-saturation: 42%;
                      --bg-lightness: 47%;
                    "
                  ></li>
                  <li
                    data-hue="217"
                    data-saturation="30"
                    data-lightness="41"
                    style="
                      --bg-hue: 217;
                      --bg-saturation: 30%;
                      --bg-lightness: 41%;
                    "
                    class="active"
                  ></li>
                  <li
                    data-hue="171"
                    data-saturation="48"
                    data-lightness="42"
                    style="
                      --bg-hue: 171;
                      --bg-saturation: 48%;
                      --bg-lightness: 42%;
                    "
                  ></li>
                  <li
                    data-hue="233"
                    data-saturation="42"
                    data-lightness="47"
                    style="
                      --bg-hue: 233;
                      --bg-saturation: 42%;
                      --bg-lightness: 47%;
                    "
                  ></li>
                  <li
                    data-hue="207"
                    data-saturation="100"
                    data-lightness="40"
                    style="
                      --bg-hue: 207;
                      --bg-saturation: 100%;
                      --bg-lightness: 40%;
                    "
                  ></li>
                </ul>
              </div>
              <!-- Background color -->
              <div
                [hidden]="
                  !searchResultMap.system?.general?.subsection1?.column1
                    ?.systemBackgroundColor
                "
              >
                <app-configurator-color-field
                  i18n-label="@@Background color"
                  label="Background color"
                  labelID="bg-color"
                  initialColor="#F8F8F8"
                >
                </app-configurator-color-field>
              </div>
            </div>
            <!-- Dark mode -->
            <aside
              class="dark-mode"
              [hidden]="!searchResultMap.system?.general?.subsection1?.darkMode"
            >
              <span class="round-icon">
                <i class="fas fa-moon"></i>
              </span>
              <app-configurator-switch-field
                [options]="{
                  fieldHeight: false,
                  wrapped: false,
                  active: false
                }"
                i18n-label="@@Dark mode"
                label="Dark mode"
              ></app-configurator-switch-field>
            </aside>
          </article>

          <!-- System colors -->
          <article
            style="--index: 6"
            [hidden]="!searchResultMap.system?.general?.colors"
          >
            <header i18n="@@System colors">System colors</header>
            <div class="cols auto wrap">
              <!-- Default -->
              <div
                [hidden]="
                  !searchResultMap.system?.general?.colors?.defaultColor
                "
              >
                <app-configurator-color-field
                  i18n-label="@@Default"
                  label="Default"
                  labelID="default-color"
                  initialColor="#4678AA"
                >
                </app-configurator-color-field>
              </div>
              <!-- Info -->
              <div
                [hidden]="!searchResultMap.system?.general?.colors?.infoColor"
              >
                <app-configurator-color-field
                  i18n-label="@@Info"
                  label="Info"
                  labelID="info-color"
                  initialColor="#4CAAE5"
                >
                </app-configurator-color-field>
              </div>
              <!-- Success -->
              <div
                [hidden]="
                  !searchResultMap.system?.general?.colors?.successColor
                "
              >
                <app-configurator-color-field
                  i18n-label="@@Success"
                  label="Success"
                  labelID="success-color"
                  initialColor="#389F8F"
                >
                </app-configurator-color-field>
              </div>
              <!-- Warning -->
              <div
                [hidden]="
                  !searchResultMap.system?.general?.colors?.warningColor
                "
              >
                <app-configurator-color-field
                  i18n-label="@@Warning"
                  label="Warning"
                  labelID="warning-color"
                  initialColor="#FFA076"
                >
                </app-configurator-color-field>
              </div>
              <!-- Danger -->
              <div
                [hidden]="!searchResultMap.system?.general?.colors?.dangerColor"
              >
                <app-configurator-color-field
                  i18n-label="@@Danger"
                  label="Danger"
                  labelID="danger-color"
                  initialColor="#F75F5F"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>

          <!-- Fonts -->
          <article
            style="--index: 5"
            [hidden]="!searchResultMap.system?.general?.fonts"
          >
            <header i18n="@@Fonts">Fonts</header>
            <div class="cols">
              <!-- Base font family -->
              <div
                [hidden]="!searchResultMap.system?.general?.fonts?.fontFamily"
              >
                <app-configurator-select-field
                  i18n-label="@@Base typography"
                  label="Base typography"
                  labelID="base-font-family"
                  [options]="{ type: 'font-family' }"
                >
                </app-configurator-select-field>
              </div>
              <!-- Base font size -->
              <div [hidden]="!searchResultMap.system?.general?.fonts?.fontSize">
                <app-configurator-input-field
                  i18n-label="@@Base font size"
                  label="Base font size"
                  labelID="base-font-size"
                  initialValue="14"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Paragraph font family -->
              <div
                [hidden]="
                  !searchResultMap.system?.general?.fonts?.paragraphFontSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Paragraph font size"
                  label="Paragraph font size"
                  labelID="paragraph-font-size"
                  initialValue="16"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <!-- Font weights -->
          <article
            style="--index: 4"
            [hidden]="!searchResultMap.system?.general?.fontWeights"
          >
            <header i18n="@@Font weights">Font weights</header>
            <div
              class="cols"
              [hidden]="!searchResultMap.system?.general?.fontWeights?.column1"
            >
              <!-- Light -->
              <div
                [hidden]="
                  !searchResultMap.system?.general?.fontWeights?.column1?.light
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Light"
                  label="Light"
                  labelID="font-weight-light-value"
                  initialValue="300"
                >
                </app-configurator-input-field>
              </div>
              <!-- Regular -->
              <div
                [hidden]="
                  !searchResultMap.system?.general?.fontWeights?.column1
                    ?.regular
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Regular"
                  label="Regular"
                  labelID="font-weight-regular-value"
                  initialValue="400"
                >
                </app-configurator-input-field>
              </div>
              <!-- Semibold -->
              <div
                [hidden]="
                  !searchResultMap.system?.general?.fontWeights?.column1
                    ?.semibold
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Semibold"
                  label="Semibold"
                  labelID="font-weight-semibold-value"
                  initialValue="600"
                >
                </app-configurator-input-field>
              </div>
            </div>
            <div
              class="cols"
              [hidden]="!searchResultMap.system?.general?.fontWeights?.column2"
            >
              <!-- Bold -->
              <div
                [hidden]="
                  !searchResultMap.system?.general?.fontWeights?.column2?.bold
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Bold"
                  label="Bold"
                  labelID="font-weight-bold-value"
                  initialValue="700"
                >
                </app-configurator-input-field>
              </div>
              <!-- Black -->
              <div
                [hidden]="
                  !searchResultMap.system?.general?.fontWeights?.column2?.black
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Black"
                  label="Black"
                  labelID="font-weight-black-value"
                  initialValue="900"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <!-- Spacing -->
          <article
            style="--index: 3"
            [hidden]="!searchResultMap.system?.general?.spacing"
          >
            <header i18n="@@Spacing">Spacing</header>
            <div class="cols">
              <!-- Base space -->
              <div
                [hidden]="!searchResultMap.system?.general?.spacing?.baseSpace"
              >
                <app-configurator-input-field
                  i18n-label="@@Base space"
                  label="Base space"
                  labelID="base-space"
                  initialValue="10"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Main areas space -->
              <div
                [hidden]="
                  !searchResultMap.system?.general?.spacing?.mainAreaSpace
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Main areas space"
                  label="Main areas space"
                  labelID="main-areas-space"
                  initialValue="50"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <!-- Scrollbar -->
          <article
            style="--index: 2"
            [hidden]="!searchResultMap.system?.general?.scrollbar"
          >
            <header i18n="@@Scrollbar">Scrollbar</header>
            <div class="cols auto">
              <!-- Track color -->
              <div
                [hidden]="
                  !searchResultMap.system?.general?.scrollbar?.trackColor
                "
              >
                <app-configurator-color-field
                  labelID="scroll-track-color"
                  i18n-label="@@Track color"
                  label="Track color"
                  initialColor="#4678AA"
                  [opacity]="30"
                >
                </app-configurator-color-field>
              </div>
              <!-- Thumb color -->
              <div
                [hidden]="
                  !searchResultMap.system?.general?.scrollbar?.thumbColor
                "
              >
                <app-configurator-color-field
                  labelID="scroll-thumb-color"
                  i18n-label="@@Thumb color"
                  label="Thumb color"
                  initialColor="#4678AA"
                  [opacity]="80"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>

          <!-- Other -->
          <article
            style="--index: 1"
            [hidden]="!searchResultMap.system?.general?.others"
          >
            <header i18n="@@Others">Others</header>
            <!-- Corner roundness -->
            <app-configurator-input-field
              [hidden]="
                !searchResultMap.system?.general?.others?.cornerRoundness
              "
              i18n-label="@@Corner roundness"
              label="Corner roundness"
              labelID="corner-roundness"
              initialValue="6"
              suffix="px"
            >
            </app-configurator-input-field>
          </article>
        </fieldset>

        <!-- Page header -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.system?.pageHeader"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Page header">Page header</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 2"
            [hidden]="!searchResultMap.system?.pageHeader?.subsection1"
          >
            <div class="cols">
              <!-- Logo max height -->
              <div
                [hidden]="
                  !searchResultMap.system?.pageHeader?.subsection1
                    ?.logoMaxHeight
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Logo max height"
                  label="Logo max height"
                  labelID="logo-height-limit"
                  initialValue="60"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Background color -->
              <div
                [hidden]="
                  !searchResultMap.system?.pageHeader?.subsection1
                    ?.backgroundColor
                "
              >
                <app-configurator-color-field
                  labelID="header-bg-color"
                  i18n-label="@@Background color"
                  label="Background color"
                  initialColor="#FFFFFF"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>

          <!-- Logout link -->
          <article
            style="--index: 1"
            [hidden]="!searchResultMap.system?.pageHeader?.logoutLink"
          >
            <header i18n="@@Logout link">Logout link</header>
            <div
              class="cols"
              [hidden]="
                !searchResultMap.system?.pageHeader?.logoutLink?.column1
              "
            >
              <!-- Text size -->
              <div
                [hidden]="
                  !searchResultMap.system?.pageHeader?.logoutLink?.column1
                    ?.textSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="logout-link-text-size"
                  initialValue="14"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div
                [hidden]="
                  !searchResultMap.system?.pageHeader?.logoutLink?.column1
                    ?.fontWeight
                "
              >
                <app-configurator-select-field
                  i18n-label="@@Font weight"
                  label="Font weight"
                  labelID="logout-link-font-weight"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
              <!-- Text color -->
              <div
                [hidden]="
                  !searchResultMap.system?.pageHeader?.logoutLink?.column1
                    ?.textColor
                "
              >
                <app-configurator-color-field
                  labelID="logout-link-text-color"
                  i18n-label="@@Text color"
                  label="Text color"
                  initialColor="#4678AA"
                >
                </app-configurator-color-field>
              </div>
            </div>
            <div
              class="cols"
              [hidden]="
                !searchResultMap.system?.pageHeader?.logoutLink?.column2
              "
            >
              <!-- Gap -->
              <div
                [hidden]="
                  !searchResultMap.system?.pageHeader?.logoutLink?.column2?.gap
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Gap"
                  label="Gap"
                  labelID="logout-link-gap"
                  initialValue="10"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Show icon -->
              <div
                [hidden]="
                  !searchResultMap.system?.pageHeader?.logoutLink?.column2
                    ?.showIcon
                "
              >
                <app-configurator-switch-field
                  [options]="{
                    fieldHeight: true,
                    labelSpace: true,
                    active: true
                  }"
                  i18n-label="@@Show icon"
                  label="Show icon"
                >
                </app-configurator-switch-field>
              </div>
            </div>
          </article>
        </fieldset>

        <!-- Menu bar -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.system?.menuBar"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Menu bar">Menu bar</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 4"
            [hidden]="!searchResultMap.system?.menuBar?.subsection1"
          >
            <div class="cols">
              <!-- Menu bar height -->
              <div
                [hidden]="
                  !searchResultMap.system?.menuBar?.subsection1?.menuBarHeight
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Menu bar height"
                  label="Menu bar height"
                  labelID="menu-bar-height"
                  initialValue="40"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Show home icon -->
              <div
                [hidden]="
                  !searchResultMap.system?.menuBar?.subsection1?.showHomeIcon
                "
              >
                <app-configurator-switch-field
                  [options]="{
                    fieldHeight: true,
                    labelSpace: true,
                    active: true
                  }"
                  i18n-label="@@Show home icon"
                  label="Show home icon"
                >
                </app-configurator-switch-field>
              </div>
            </div>
          </article>

          <!-- Breadcrumbs -->
          <article
            style="--index: 3"
            [hidden]="!searchResultMap.system?.menuBar?.breadcrumbs"
          >
            <header i18n="@@Breadcrumbs">Breadcrumbs</header>
            <div
              class="cols"
              [hidden]="!searchResultMap.system?.menuBar?.breadcrumbs?.column1"
            >
              <!-- Text size -->
              <div
                [hidden]="
                  !searchResultMap.system?.menuBar?.breadcrumbs?.column1
                    ?.textSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="breadcrumbs-text-size"
                  initialValue="16"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div
                [hidden]="
                  !searchResultMap.system?.menuBar?.breadcrumbs?.column1
                    ?.fontWeight
                "
              >
                <app-configurator-select-field
                  i18n-label="@@Font weight"
                  label="Font weight"
                  labelID="breadcrumbs-font-weight"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
              <!-- Text color -->
              <div
                [hidden]="
                  !searchResultMap.system?.menuBar?.breadcrumbs?.column1
                    ?.textColor
                "
              >
                <app-configurator-color-field
                  labelID="breadcrumbs-text-color"
                  i18n-label="@@Text color"
                  label="Text color"
                  initialColor="#FFFFFF"
                >
                </app-configurator-color-field>
              </div>
            </div>
            <div
              class="cols"
              [hidden]="
                !searchResultMap.system?.menuBar?.breadcrumbs?.separatorSize
              "
            >
              <!-- Separator size -->
              <div>
                <app-configurator-input-field
                  i18n-label="@@Separator size"
                  label="Separator size"
                  labelID="breadcrumbs-separator-size"
                  initialValue="10"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <!-- Menu -->
          <article
            style="--index: 2"
            [hidden]="!searchResultMap.system?.menuBar?.menu"
          >
            <header i18n="@@Menu">Menu</header>
            <div class="cols">
              <!-- Text size -->
              <div [hidden]="!searchResultMap.system?.menuBar?.menu?.textSize">
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="usermenu-text-size"
                  initialValue="16"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div
                [hidden]="!searchResultMap.system?.menuBar?.menu?.fontWeight"
              >
                <app-configurator-select-field
                  i18n-label="@@Font weight"
                  label="Font weight"
                  labelID="usermenu-font-weight"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
              <!-- Text color -->
              <div [hidden]="!searchResultMap.system?.menuBar?.menu?.textColor">
                <app-configurator-color-field
                  labelID="usermenu-text-color"
                  i18n-label="@@Text color"
                  label="Text color"
                  initialColor="#FFFFFF"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>

          <!-- Dropdown menu -->
          <article
            style="--index: 1"
            [hidden]="!searchResultMap.system?.menuBar?.dropdownMenu"
          >
            <header i18n="@@Dropdown menu">Dropdown menu</header>
            <div
              class="cols auto"
              [hidden]="!searchResultMap.system?.menuBar?.dropdownMenu?.column1"
            >
              <!-- Show icons -->
              <div
                [hidden]="
                  !searchResultMap.system?.menuBar?.dropdownMenu?.column1
                    ?.showIcons
                "
              >
                <app-configurator-switch-field
                  [options]="{
                    labelSpace: true,
                    active: true
                  }"
                  i18n-label="@@Show icons"
                  label="Show icons"
                >
                </app-configurator-switch-field>
              </div>
              <!-- Icons color -->
              <div
                [hidden]="
                  !searchResultMap.system?.menuBar?.dropdownMenu?.column1
                    ?.iconsColor
                "
              >
                <app-configurator-color-field
                  labelID="icons-color"
                  i18n-label="@@Icons color"
                  label="Icons color"
                  initialColor="#4678AA"
                >
                </app-configurator-color-field>
              </div>
            </div>
            <div
              class="cols"
              [hidden]="!searchResultMap.system?.menuBar?.dropdownMenu?.column2"
            >
              <!-- Item height -->
              <div
                [hidden]="
                  !searchResultMap.system?.menuBar?.dropdownMenu?.column2
                    ?.itemHeight
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Item height"
                  label="Item height"
                  labelID="usermenu-item-height"
                  initialValue="40"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Divider height -->
              <div
                [hidden]="
                  !searchResultMap.system?.menuBar?.dropdownMenu?.column2
                    ?.dividerHeight
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Separator height"
                  label="Separator height"
                  labelID="usermenu-divider-height"
                  initialValue="1"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
            <div
              class="cols"
              [hidden]="!searchResultMap.system?.menuBar?.dropdownMenu?.column3"
            >
              <!-- Item text size -->
              <div
                [hidden]="
                  !searchResultMap.system?.menuBar?.dropdownMenu?.column3
                    ?.textSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="usermenu-item-text-size"
                  initialValue="14"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Item text color -->
              <div
                [hidden]="
                  !searchResultMap.system?.menuBar?.dropdownMenu?.column3
                    ?.textColor
                "
              >
                <app-configurator-color-field
                  labelID="usermenu-item-text-color"
                  i18n-label="@@Text color"
                  label="Text color"
                  initialColor="#000000"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>
        </fieldset>

        <!-- Dashboard -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="
            !searchResultMap.system?.dashboard ||
            !routeVisibilityMap.system?.dashboard
          "
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Dashboard">Dashboard</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <!-- Tabs -->
          <article
            style="--index: 5"
            [hidden]="!searchResultMap.system?.dashboard?.tabs"
          >
            <header i18n="@@Tabs">Tabs</header>
            <div
              class="cols"
              [hidden]="!searchResultMap.system?.dashboard?.tabs?.column1"
            >
              <!-- Tab font size -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.tabs?.column1?.textSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="dashboard-tab-text-size"
                  initialValue="21"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Corner roundness -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.tabs?.column1
                    ?.cornerRoundness
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Corner roundness"
                  label="Corner roundness"
                  labelID="dashboard-tab-corner-roundness"
                  initialValue="10"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
            <div
              class="cols"
              [hidden]="!searchResultMap.system?.dashboard?.tabs?.column2"
            >
              <!-- Tab pill vertical padding -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.tabs?.column2
                    ?.tabPillYPadding
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Tab pill vertical padding"
                  label="Tab pill vertical padding"
                  labelID="dashboard-tab-content-padding"
                  initialValue="18"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Content padding -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.tabs?.column2
                    ?.contentPadding
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Content padding"
                  label="Content padding"
                  labelID="dashboard-tab-content-padding"
                  initialValue="35"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <!-- Lists headings -->
          <article
            style="--index: 4"
            [hidden]="!searchResultMap.system?.dashboard?.listsHeading"
          >
            <header i18n="@@Lists heading">Lists heading</header>
            <div
              class="cols"
              [hidden]="
                !searchResultMap.system?.dashboard?.listsHeading?.column1
              "
            >
              <!-- Text size -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.listsHeading?.column1
                    ?.textSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="dashboard-list-heading-text-size"
                  initialValue="14"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.listsHeading?.column1
                    ?.fontWeight
                "
              >
                <app-configurator-select-field
                  i18n-label="@@Font weight"
                  label="Font weight"
                  labelID="dashboard-list-heading-font-weight"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
            </div>
            <div
              class="cols auto"
              [hidden]="
                !searchResultMap.system?.dashboard?.listsHeading?.column2
              "
            >
              <!-- Text color -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.listsHeading?.column2
                    ?.textColor
                "
              >
                <app-configurator-color-field
                  i18n-label="@@Text color"
                  label="Text color"
                  labelID="list-heading-text-color"
                  initialColor="#4A6288"
                >
                </app-configurator-color-field>
              </div>
              <!-- Background color -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.listsHeading?.column2
                    ?.backgroundColor
                "
              >
                <app-configurator-color-field
                  i18n-label="@@Background color"
                  label="Background color"
                  labelID="list-heading-bg-color"
                  initialColor="#FFFFFF"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>

          <!-- Lists rows -->
          <article
            style="--index: 3"
            [hidden]="!searchResultMap.system?.dashboard?.listsRows"
          >
            <header i18n="@@List rows">List rows</header>
            <div class="cols">
              <!-- Text size -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.listsRows?.textSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="dashboard-list-row-text-size"
                  initialValue="15"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.listsRows?.fontWeight
                "
              >
                <app-configurator-select-field
                  i18n-label="@@Font weight"
                  label="Font weight"
                  labelID="dashboard-list-row-font-weight"
                  [defaultValue]="600"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
            </div>
          </article>

          <!-- Lists pagination -->
          <article
            style="--index: 2"
            [hidden]="!searchResultMap.system?.dashboard?.listsPagination"
          >
            <header i18n="@@List pagination">List pagination</header>
            <div
              class="cols"
              [hidden]="
                !searchResultMap.system?.dashboard?.listsPagination?.column1
              "
            >
              <!-- Height -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.listsPagination?.column1
                    ?.height
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Height"
                  label="Height"
                  labelID="dashboard-list-pagination-height"
                  initialValue="16"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Text size -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.listsPagination?.column1
                    ?.textSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="dashboard-list-pagination-text-size"
                  initialValue="16"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.listsPagination?.column1
                    ?.fontWeight
                "
              >
                <app-configurator-select-field
                  i18n-label="@@Font weight"
                  label="Font weight"
                  labelID="dashboard-list-pagination-font-weight"
                  [defaultValue]="700"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
            </div>
            <div
              class="cols"
              [hidden]="
                !searchResultMap.system?.dashboard?.listsPagination?.column2
              "
            >
              <!-- Pagination top space -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.listsPagination?.column2
                    ?.topSpace
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Pagination top space"
                  label="Pagination top space"
                  labelID="dashboard-list-pagination-top-space"
                  initialValue="32"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <!-- Status legend filter -->
          <article
            style="--index: 1"
            [hidden]="!searchResultMap.system?.dashboard?.statusLegend"
          >
            <header i18n="@@Status legend filter">Status legend filter</header>
            <div class="cols">
              <!-- Top space -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.statusLegend?.topSpace
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Label top space"
                  label="Label top space"
                  labelID="dashboard-list-status-legend-filter-top-space"
                  initialValue="24"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font size -->
              <div
                [hidden]="
                  !searchResultMap.system?.dashboard?.statusLegend?.textSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="dashboard-list-status-legend-filter-text-size"
                  initialValue="12"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>
        </fieldset>

        <!-- Available Services -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="
            !searchResultMap.system?.availableServices ||
            !routeVisibilityMap.system?.availableServices
          "
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Available services">Available services</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 4"
            [hidden]="
              !searchResultMap.system?.availableServices?.sectionTitleSearchGap
            "
          >
            <div class="cols">
              <!-- Section title and search gap -->
              <div>
                <app-configurator-input-field
                  i18n-label="@@Section title and search gap"
                  label="Section title and search gap"
                  labelID="available-services-section-title-search-gap"
                  initialValue="32"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <!-- Cards -->
          <article
            style="--index: 3"
            [hidden]="!searchResultMap.system?.availableServices?.cards"
          >
            <header i18n="@@Cards">Cards</header>
            <div
              class="cols"
              [hidden]="
                !searchResultMap.system?.availableServices?.cards?.column1
              "
            >
              <!-- Service card roundness -->
              <div
                [hidden]="
                  !searchResultMap.system?.availableServices?.cards?.column1
                    ?.roundnessCorners
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Border roundness"
                  label="Border roundness"
                  labelID="available-services-card-roundness"
                  initialValue="10"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Service card gap -->
              <div
                [hidden]="
                  !searchResultMap.system?.availableServices?.cards?.column1
                    ?.gap
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Gap"
                  label="Gap"
                  labelID="available-services-card-gap"
                  initialValue="32"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
            <div
              class="cols auto wrap"
              [hidden]="
                !searchResultMap.system?.availableServices?.cards?.column2
              "
            >
              <!-- Show service image -->
              <div
                [hidden]="
                  !searchResultMap.system?.availableServices?.cards?.column2
                    ?.showServiceImage
                "
              >
                <app-configurator-switch-field
                  [options]="{
                    fieldHeight: true,
                    active: true
                  }"
                  i18n-label="@@Show service image"
                  label="Show service image"
                >
                </app-configurator-switch-field>
              </div>
              <!-- Service card initial shadow -->
              <div
                [hidden]="
                  !searchResultMap.system?.availableServices?.cards?.column2
                    ?.initialShadow
                "
              >
                <app-configurator-shadow-field
                  i18n-label="@@Initial shadow"
                  label="Initial shadow"
                  [initialX]="0"
                  [initialY]="3"
                  [initialB]="60"
                  [colorOpacity]="2.5"
                >
                </app-configurator-shadow-field>
              </div>
              <!-- Service card mouseover shadow -->
              <div
                [hidden]="
                  !searchResultMap.system?.availableServices?.cards?.column2
                    ?.mouseoverShadow
                "
              >
                <app-configurator-shadow-field
                  i18n-label="@@Mouseover shadow"
                  label="Mouseover shadow"
                  [initialX]="0"
                  [initialY]="6"
                  [initialB]="20"
                  [colorOpacity]="10"
                >
                </app-configurator-shadow-field>
              </div>
            </div>
          </article>

          <!-- Card title -->
          <article
            style="--index: 2"
            [hidden]="!searchResultMap.system?.availableServices?.cardTitle"
          >
            <header i18n="@@Card title">Card title</header>
            <div class="cols">
              <!-- Text size -->
              <div
                [hidden]="
                  !searchResultMap.system?.availableServices?.cardTitle
                    ?.textSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="card-title-text-size"
                  initialValue="17"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div
                [hidden]="
                  !searchResultMap.system?.availableServices?.cardTitle
                    ?.fontWeight
                "
              >
                <app-configurator-select-field
                  i18n-label="@@Font weight"
                  label="Font weight"
                  labelID="card-title-font-weight"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
              <!-- Text color -->
              <div
                [hidden]="
                  !searchResultMap.system?.availableServices?.cardTitle
                    ?.textColor
                "
              >
                <app-configurator-color-field
                  labelID="card-title-text-color"
                  i18n-label="@@Text color"
                  label="Text color"
                  initialColor="#4678AA"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>

          <!-- Card description -->
          <article
            style="--index: 1"
            [hidden]="
              !searchResultMap.system?.availableServices?.cardDescription
            "
          >
            <header i18n="@@Card description">Card description</header>
            <div class="cols">
              <!-- Text size -->
              <div
                [hidden]="
                  !searchResultMap.system?.availableServices?.cardDescription
                    ?.textSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="card-description-text-size"
                  initialValue="14"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div
                [hidden]="
                  !searchResultMap.system?.availableServices?.cardDescription
                    ?.fontWeight
                "
              >
                <app-configurator-select-field
                  i18n-label="@@Font weight"
                  label="Font weight"
                  labelID="card-description-font-weight"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
              <!-- Text color -->
              <div
                [hidden]="
                  !searchResultMap.system?.availableServices?.cardDescription
                    ?.textColor
                "
              >
                <app-configurator-color-field
                  labelID="card-description-text-color"
                  i18n-label="@@Text color"
                  label="Text color"
                  initialColor="#000000"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>
        </fieldset>

        <!-- Footer -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.system?.footer"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Footer">Footer</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article style="--index: 1">
            <div class="cols">
              <!-- Text size -->
              <div [hidden]="!searchResultMap.system?.footer?.textSize">
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="footer-text-size"
                  initialValue="12"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div [hidden]="!searchResultMap.system?.footer?.fontWeight">
                <app-configurator-select-field
                  i18n-label="@@Font weight"
                  label="Font weight"
                  labelID="footer-font-weight"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
              <!-- Text color -->
              <div [hidden]="!searchResultMap.system?.footer?.textColor">
                <app-configurator-color-field
                  labelID="footer-text-color"
                  i18n-label="@@Text color"
                  label="Text color"
                  initialColor="#000000"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>
        </fieldset>
      </div>
    </section>

    <section class="forms" [ngClass]="{ active: activeTab === 'forms' }">
      <div class="search-field-container configurator-field">
        <label for="configuration-filter-forms">
          <span class="sr-only" i18n="@@Search forms">Search forms</span>
          <i class="far fa-magnifying-glass"></i>
        </label>
        <input
          type="text"
          [(ngModel)]="searchTermText"
          (ngModelChange)="onChangeSearchTerm()"
          id="configuration-filter-forms"
          name="configuration-filter"
          class="configuration-filter"
          i18n-placeholder="@@Search..."
          placeholder="Search..."
        />
      </div>

      <div class="properties-container">
        <!-- General -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.general"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@General">General</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 1"
            [hidden]="!searchResultMap.forms?.general?.componentSeparation"
          >
            <!-- Component separation -->
            <app-configurator-input-field
              i18n-label="@@Component separation"
              label="Component separation"
              labelID="component-separation"
              initialValue="30"
              suffix="px"
            >
            </app-configurator-input-field>
          </article>
        </fieldset>

        <!-- Wizard -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.wizard"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Wizard">Wizard</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 3"
            [hidden]="!searchResultMap.forms?.wizard?.gradientTopColor"
          >
            <!-- Gradient top color -->
            <app-configurator-color-field
              labelID="gradient-top-color"
              i18n-label="@@Gradient top color"
              label="Gradient top color"
              initialColor="#F0F0F0"
              [opacity]="100"
            >
            </app-configurator-color-field>
          </article>

          <!-- Page link -->
          <article
            style="--index: 2"
            [hidden]="!searchResultMap.forms?.wizard?.pageLink"
          >
            <header i18n="@@Page link">Page link</header>
            <div
              class="cols"
              [hidden]="!searchResultMap.forms?.wizard?.pageLink?.column1"
            >
              <!-- Text size -->
              <div
                [hidden]="
                  !searchResultMap.forms?.wizard?.pageLink?.column1?.textSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="wizard-page-link-text-size"
                  initialValue="20"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div
                [hidden]="
                  !searchResultMap.forms?.wizard?.pageLink?.column1?.fontWeight
                "
              >
                <app-configurator-select-field
                  i18n-label="@@Font weight"
                  label="Font weight"
                  labelID="wizard-page-link-font-weight"
                  [defaultValue]="700"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
            </div>
            <div
              class="cols"
              [hidden]="!searchResultMap.forms?.wizard?.pageLink?.column2"
            >
              <!-- Horizontal padding -->
              <div
                [hidden]="
                  !searchResultMap.forms?.wizard?.pageLink?.column2
                    ?.horizontalPadding
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Horizontal padding"
                  label="Horizontal padding"
                  labelID="wizard-page-link-horizontal-padding"
                  initialValue="20"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Vertical padding -->
              <div
                [hidden]="
                  !searchResultMap.forms?.wizard?.pageLink?.column2
                    ?.verticalPadding
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Vertical padding"
                  label="Vertical padding"
                  labelID="wizard-page-link-vertical-padding"
                  initialValue="16"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Pill width -->
              <div
                [hidden]="
                  !searchResultMap.forms?.wizard?.pageLink?.column2?.pillWidth
                "
              >
                <app-configurator-select-field
                  i18n-label="@@Pill width"
                  label="Pill width"
                  labelID="wizard-page-link-width"
                  [options]="{ type: 'generic' }"
                  [itemList]="[
                    { value: '1', text: 'ds-config-equal-full-width' },
                    { value: 'initial', text: 'ds-config-adjust-to-text' },
                    { value: 'auto', text: 'ds-config-auto-full-width' }
                  ]"
                  [defaultValue]="1"
                >
                </app-configurator-select-field>
              </div>
            </div>
          </article>

          <!-- Progress bar -->
          <article
            style="--index: 1"
            [hidden]="!searchResultMap.forms?.wizard?.progressBar"
          >
            <header i18n="@@Progress bar">Progress bar</header>
            <div class="cols">
              <!-- Height -->
              <div
                [hidden]="!searchResultMap.forms?.wizard?.progressBar?.height"
              >
                <app-configurator-input-field
                  i18n-label="@@Height"
                  label="Height"
                  labelID="wizard-page-link-progress-bar-height"
                  initialValue="4"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Bottom distance -->
              <div
                [hidden]="
                  !searchResultMap.forms?.wizard?.progressBar?.bottomDistance
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Bottom distance"
                  label="Bottom distance"
                  labelID="wizard-page-link-progress-bar-bottom-distance"
                  initialValue="8"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>
        </fieldset>

        <!-- Labels -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.labels"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Labels">Labels</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 2"
            [hidden]="!searchResultMap.forms?.labels?.subsection1"
          >
            <div
              class="cols"
              [hidden]="!searchResultMap.forms?.labels?.subsection1?.column1"
            >
              <!-- Text size -->
              <div
                [hidden]="
                  !searchResultMap.forms?.labels?.subsection1?.column1?.textSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="labels-text-size"
                  initialValue="14"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div
                [hidden]="
                  !searchResultMap.forms?.labels?.subsection1?.column1
                    ?.fontWeight
                "
              >
                <app-configurator-select-field
                  i18n-label="@@Font weight"
                  label="Font weight"
                  labelID="labels-font-weight"
                  [defaultValue]="600"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
              <!-- Line height -->
              <div
                [hidden]="
                  !searchResultMap.forms?.labels?.subsection1?.column1
                    ?.lineHeight
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Line height"
                  label="Line height"
                  labelID="labels-line-height"
                  initialValue="18"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
            <div
              class="cols"
              [hidden]="
                !searchResultMap.forms?.labels?.subsection1?.verticalPadding
              "
            >
              <!-- Vertical padding -->
              <div>
                <app-configurator-input-field
                  i18n-label="@@Vertical padding"
                  label="Vertical padding"
                  labelID="labels-vertical-padding"
                  initialValue="4"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <!-- Required mark -->
          <article
            style="--index: 1"
            [hidden]="!searchResultMap.forms?.labels?.requiredMark"
          >
            <header i18n="@@Required mark">Required mark</header>
            <div class="cols">
              <!-- Symbol -->
              <div
                [hidden]="!searchResultMap.forms?.labels?.requiredMark?.symbol"
              >
                <app-configurator-input-field
                  i18n-label="@@Symbol"
                  label="Symbol"
                  labelID="labels-required-mark-symbol"
                  initialValue="●"
                >
                </app-configurator-input-field>
              </div>
              <!-- Size -->
              <div
                [hidden]="!searchResultMap.forms?.labels?.requiredMark?.size"
              >
                <app-configurator-input-field
                  i18n-label="@@Required mark size"
                  label="Required mark size"
                  labelID="labels-required-mark-size"
                  initialValue="14"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Color -->
              <div
                [hidden]="!searchResultMap.forms?.labels?.requiredMark?.color"
              >
                <app-configurator-color-field
                  i18n-label="@@Color"
                  label="Color"
                  labelID="labels-required-mark-color"
                  initialColor="#EB0000"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>
        </fieldset>

        <!-- Fields -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.fields"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Fields">Fields</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 4"
            [hidden]="!searchResultMap.forms?.fields?.subsection1"
          >
            <div class="cols">
              <!-- Height -->
              <div
                [hidden]="!searchResultMap.forms?.fields?.subsection1?.height"
              >
                <app-configurator-input-field
                  i18n-label="@@Height"
                  label="Height"
                  labelID="fields-height"
                  initialValue="36"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Horizontal padding -->
              <div
                [hidden]="
                  !searchResultMap.forms?.fields?.subsection1?.horizontalPadding
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Horizontal padding"
                  label="Horizontal padding"
                  labelID="fields-horizontal-padding"
                  initialValue="12"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <article
            style="--index: 3"
            [hidden]="!searchResultMap.forms?.fields?.subsection2"
          >
            <div class="cols">
              <!-- Text size -->
              <div
                [hidden]="!searchResultMap.forms?.fields?.subsection2?.textSize"
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="fields-text-size"
                  initialValue="16"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div
                [hidden]="
                  !searchResultMap.forms?.fields?.subsection2?.fontWeight
                "
              >
                <app-configurator-select-field
                  i18-label="@@Font weight"
                  label="Font weight"
                  labelID="fields-font-weight"
                  [defaultValue]="600"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
              <!-- Text color -->
              <div
                [hidden]="
                  !searchResultMap.forms?.fields?.subsection2?.textColor
                "
              >
                <app-configurator-color-field
                  i18n-label="@@Color"
                  label="Color"
                  labelID="fields-text-color"
                  initialColor="#1F1F1F"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>

          <article
            style="--index: 2"
            [hidden]="!searchResultMap.forms?.fields?.subsection3"
          >
            <div class="cols">
              <!-- Vertical padding -->
              <div
                [hidden]="
                  !searchResultMap.forms?.fields?.subsection3?.verticalPadding
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Vertical padding"
                  label="Vertical padding"
                  labelID="fields-vertical-padding"
                  initialValue="4"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Border size -->
              <div
                [hidden]="
                  !searchResultMap.forms?.fields?.subsection3?.borderWidth
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Border width"
                  label="Border width"
                  labelID="fields-border-width"
                  initialValue="1"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Border color -->
              <div
                [hidden]="
                  !searchResultMap.forms?.fields?.subsection3?.borderColor
                "
              >
                <app-configurator-color-field
                  i18n-label="@@Border color"
                  label="Border color"
                  labelID="fields-border-color"
                  initialColor="#496188"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>

          <!-- Prefix and suffix -->
          <article
            style="--index: 1"
            [hidden]="!searchResultMap.forms?.fields?.prefixSuffix"
          >
            <header i18n="@@Prefix and suffix">Prefix and suffix</header>
            <div class="cols">
              <!-- Font weight -->
              <div
                [hidden]="
                  !searchResultMap.forms?.fields?.prefixSuffix?.fontWeight
                "
              >
                <app-configurator-select-field
                  i18n-label="@@Font weight"
                  label="Font weight"
                  labelID="fields-prefix-suffix-font-weight"
                  [defaultValue]="700"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
              <!-- Background opacity -->
              <div
                [hidden]="
                  !searchResultMap.forms?.fields?.prefixSuffix
                    ?.backgroundOpacity
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Background opacity"
                  label="Background opacity"
                  labelID="fields-prefix-suffix-background-opacity"
                  initialValue="10"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>
        </fieldset>

        <!-- Buttons -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.buttons"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Buttons">Buttons</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article style="--index: 1">
            <div class="cols">
              <!-- Default Text size -->
              <div [hidden]="!searchResultMap.forms?.buttons?.defaultTextSize">
                <app-configurator-input-field
                  i18n-label="@@Default text size"
                  label="Default text size"
                  labelID="buttons-default-text-size"
                  initialValue="16"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Rounded corners -->
              <div [hidden]="!searchResultMap.forms?.buttons?.cornerRoundness">
                <app-configurator-input-field
                  i18n-label="@@Corner roundness"
                  label="Corner roundness"
                  labelID="buttons-corner-roundness"
                  initialValue="6"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>
        </fieldset>

        <!-- Catalogs -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.catalogs"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Catalogs">Catalogs</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article style="--index: 1">
            <!-- Dropdown max height -->
            <div [hidden]="!searchResultMap.forms?.catalogs?.dropdownMaxHeight">
              <app-configurator-input-field
                i18n-label="@@Max height"
                label="Max height"
                labelID="dropdown-max-height"
                initialValue="206"
                suffix="px"
              >
              </app-configurator-input-field>
            </div>
          </article>
        </fieldset>

        <!-- Checkbox -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.checkbox"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Checkbox">Checkbox</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 1"
            [hidden]="
              !searchResultMap.forms?.checkbox?.inlineHorizontalSeparation
            "
          >
            <!-- Inline horizontal separation -->
            <app-configurator-input-field
              i18n-label="@@Inline horizontal separation"
              label="Inline horizontal separation"
              labelID="checkbox-inline-horizontal-separation"
              initialValue="16"
              suffix="px"
            >
            </app-configurator-input-field>
          </article>
        </fieldset>

        <!-- Tabs -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.tabs"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Tabs">Tabs</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 4"
            [hidden]="!searchResultMap.forms?.tabs?.subsection1"
          >
            <div class="cols">
              <!-- Border width -->
              <div
                [hidden]="
                  !searchResultMap.forms?.tabs?.subsection1?.borderWidth
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Border width"
                  label="Border width"
                  labelID="tabs-border-width"
                  initialValue="8"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Border color -->
              <div
                [hidden]="
                  !searchResultMap.forms?.tabs?.subsection1?.borderColor
                "
              >
                <app-configurator-color-field
                  i18n-label="@@Border color"
                  label="Border color"
                  labelID="tabs-border-color"
                  initialColor="#FFFFFF"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>

          <!-- Tab pill -->
          <article style="--index: 3">
            <header i18n="@@Tab pill">Tab pill</header>
            <div
              class="cols"
              [hidden]="!searchResultMap.forms?.tabs?.tabPill?.column1"
            >
              <!-- Container top padding -->
              <div
                [hidden]="
                  !searchResultMap.forms?.tabs?.tabPill?.column1
                    ?.containerPaddingTop
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Container top padding"
                  label="Container top padding"
                  labelID="tabs-container-padding"
                  initialValue="0"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Container horizontal padding -->
              <div
                [hidden]="
                  !searchResultMap.forms?.tabs?.tabPill?.column1
                    ?.containerPaddingInline
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Container horizontal padding"
                  label="Container horizontal padding"
                  labelID="tabs-container-padding"
                  initialValue="0"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Container bottom border width -->
              <div
                [hidden]="
                  !searchResultMap.forms?.tabs?.tabPill?.column1
                    ?.containerBottomBorderWidth
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Container bottom border width"
                  label="Container bottom border width"
                  labelID="tabs-container-bottom-border-width"
                  initialValue="8"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <article
            style="--index: 2"
            [hidden]="!searchResultMap.forms?.tabs?.tabPill?.column2"
          >
            <div class="cols">
              <!-- Horizontal padding -->
              <div
                [hidden]="
                  !searchResultMap.forms?.tabs?.tabPill?.column2
                    ?.horizontalPadding
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Horizontal padding"
                  label="Horizontal padding"
                  labelID="tabs-horizontal-padding"
                  initialValue="16"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Vertical Padding -->
              <div
                [hidden]="
                  !searchResultMap.forms?.tabs?.tabPill?.column2
                    ?.verticalPadding
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Vertical padding"
                  label="Vertical padding"
                  labelID="tabs-vertical-padding"
                  initialValue="8"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <article
            style="--index: 1"
            [hidden]="!searchResultMap.forms?.tabs?.tabPill?.column3"
          >
            <div class="cols">
              <!-- Font size -->
              <div
                [hidden]="
                  !searchResultMap.forms?.tabs?.tabPill?.column3?.textSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="tabs-pill-font-size"
                  initialValue="20"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Active tab background color -->
              <div
                [hidden]="
                  !searchResultMap.forms?.tabs?.tabPill?.column3
                    ?.activeTabBgColor
                "
              >
                <app-configurator-color-field
                  i18n-label="@@Active tab background color"
                  label="Active tab background color"
                  labelID="labels-active-tab-background-color"
                  initialColor="#F0F0F0"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>
        </fieldset>

        <!-- Blocks -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.blocks"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Blocks / Panels">Blocks / Panels</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 4"
            [hidden]="!searchResultMap.forms?.blocks?.subsection1"
          >
            <div class="cols">
              <!-- Card background color -->
              <div
                [hidden]="
                  !searchResultMap.forms?.blocks?.subsection1?.cardBgColor
                "
              >
                <app-configurator-color-field
                  i18n-label="@@Card background color"
                  label="Card background color"
                  labelID="blocks-card-background-color"
                  initialColor="#FFFFFF"
                >
                </app-configurator-color-field>
              </div>
              <!-- Body padding -->
              <div
                [hidden]="
                  !searchResultMap.forms?.blocks?.subsection1?.bodyPadding
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Body padding"
                  label="Body padding"
                  labelID="blocks-body-padding"
                  initialValue="20"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <!-- Heading -->
          <article style="--index: 3">
            <header i18n="@@Block heading">Block heading</header>
            <div
              class="cols"
              [hidden]="!searchResultMap.forms?.blocks?.blockHeading?.column1"
            >
              <!-- Text size -->
              <div
                [hidden]="
                  !searchResultMap.forms?.blocks?.blockHeading?.column1
                    ?.textSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="blocks-heading-font-size"
                  initialValue="21"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div
                [hidden]="
                  !searchResultMap.forms?.blocks?.blockHeading?.column1
                    ?.fontWeight
                "
              >
                <app-configurator-select-field
                  i18n-label="@@Font weight"
                  label="Font weight"
                  labelID="blocks-heading-font-weight"
                  [defaultValue]="700"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
              <!-- Text color -->
              <div
                [hidden]="
                  !searchResultMap.forms?.blocks?.blockHeading?.column1
                    ?.textColor
                "
              >
                <app-configurator-color-field
                  i18n-label="@@Text color"
                  label="Text color"
                  labelID="blocks-heading-text-color"
                  initialColor="#F5F5F5"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>

          <article
            style="--index: 2"
            [hidden]="!searchResultMap.forms?.blocks?.blockHeading?.column2"
          >
            <div class="cols">
              <!-- Horizontal padding -->
              <div
                [hidden]="
                  !searchResultMap.forms?.blocks?.blockHeading?.column2
                    ?.horizontalPadding
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Horizontal padding"
                  label="Horizontal padding"
                  labelID="blocks-heading-x-padding"
                  initialValue="20"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Vertical padding -->
              <div
                [hidden]="
                  !searchResultMap.forms?.blocks?.blockHeading?.column2
                    ?.verticalPadding
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Vertical padding"
                  label="Vertical padding"
                  labelID="blocks-body-y-padding"
                  initialValue="16"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <article
            style="--index: 1"
            [hidden]="!searchResultMap.forms?.blocks?.blockHeading?.column3"
          >
            <div class="cols auto">
              <!-- Border color -->
              <div
                [hidden]="
                  !searchResultMap.forms?.blocks?.blockHeading?.column3
                    ?.borderColor
                "
              >
                <app-configurator-color-field
                  i18n-label="@@Border color"
                  label="Border color"
                  labelID="blocks-heading-border-color"
                  initialColor="#F5F5F5"
                >
                </app-configurator-color-field>
              </div>
              <!-- Background color -->
              <div
                [hidden]="
                  !searchResultMap.forms?.blocks?.blockHeading?.column3
                    ?.backgroundColor
                "
              >
                <app-configurator-color-field
                  i18n-label="@@Background color"
                  label="Background color"
                  labelID="blocks-heading-background-color"
                  initialColor="#FFFFFF"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>
        </fieldset>

        <!-- Fieldset -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.fieldset"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Fieldset">Fieldset</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 2"
            [hidden]="!searchResultMap.forms?.fieldset?.borderWidth"
          >
            <!-- Border width -->
            <app-configurator-input-field
              i18n-label="@@Border width"
              label="Border width"
              labelID="fieldset-border-width"
              initialValue="4"
              suffix="px"
            >
            </app-configurator-input-field>
          </article>

          <!-- Legend -->
          <article
            style="--index: 1"
            [hidden]="!searchResultMap.forms?.fieldset?.legend"
          >
            <header i18n="@@Legend">Legend</header>
            <div class="cols">
              <!-- Text size -->
              <div
                [hidden]="!searchResultMap.forms?.fieldset?.legend?.textSize"
              >
                <app-configurator-input-field
                  i18n-label="@@Text size"
                  label="Text size"
                  labelID="fieldset-legend-font-size"
                  initialValue="18"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div
                [hidden]="!searchResultMap.forms?.fieldset?.legend?.fontWeight"
              >
                <app-configurator-select-field
                  i18n-label="@@Font weight"
                  label="Font weight"
                  labelID="fieldset-legend-font-weight"
                  [defaultValue]="700"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
            </div>
          </article>
        </fieldset>

        <!-- Content -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.content"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Content">Content</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 1"
            [hidden]="!searchResultMap.forms?.content?.textLinesSeparation"
          >
            <!-- Text lines separation -->
            <app-configurator-input-field
              i18n-label="@@Text lines separation"
              label="Text lines separation"
              labelID="content-text-lines-separation"
              initialValue="8"
              suffix="px"
            >
            </app-configurator-input-field>
          </article>
        </fieldset>

        <!-- Notices -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.notices"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Notices">Notices</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 2"
            [hidden]="!searchResultMap.forms?.notices?.subsection1"
          >
            <div class="cols">
              <!-- Border width -->
              <div
                [hidden]="
                  !searchResultMap.forms?.notices?.subsection1?.borderWidth
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Border width"
                  label="Border width"
                  labelID="notice-border-width"
                  initialValue="1"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Side border width -->
              <div
                [hidden]="
                  !searchResultMap.forms?.notices?.subsection1?.sideBorderWidth
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Side border width"
                  label="Side border width"
                  labelID="notice-side-border-width"
                  initialValue="4"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <article
            style="--index: 1"
            [hidden]="!searchResultMap.forms?.notices?.subsection2"
          >
            <div class="cols">
              <!-- Corner roundness -->
              <div
                [hidden]="
                  !searchResultMap.forms?.notices?.subsection2?.cornerRoundness
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Corner roundness"
                  label="Corner roundness"
                  labelID="notice-corner-roundness"
                  initialValue="3"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Horizontal padding -->
              <div
                [hidden]="
                  !searchResultMap.forms?.notices?.subsection2
                    ?.horizontalPadding
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Horizontal padding"
                  label="Horizontal padding"
                  labelID="notice-horizontal-padding"
                  initialValue="12"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Vertical padding -->
              <div
                [hidden]="
                  !searchResultMap.forms?.notices?.subsection2?.verticalPadding
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Vertical padding"
                  label="Vertical padding"
                  labelID="notice-vertical-padding"
                  initialValue="10"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>
        </fieldset>

        <!-- Datagrid -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.datagrid"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Datagrid">Datagrid</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 2"
            [hidden]="!searchResultMap.forms?.datagrid?.subsection1"
          >
            <div class="cols">
              <!-- Border width -->
              <div
                [hidden]="
                  !searchResultMap.forms?.datagrid?.subsection1?.borderWidth
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Border width"
                  label="Border width"
                  labelID="datagrid-border-width"
                  initialValue="2"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Cell border width -->
              <div
                [hidden]="
                  !searchResultMap.forms?.datagrid?.subsection1?.cellBorderWidth
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Cell border width"
                  label="Cell border width"
                  labelID="datagrid-cell-border-width"
                  initialValue="2"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>

          <article
            style="--index: 1"
            [hidden]="!searchResultMap.forms?.datagrid?.subsection2"
          >
            <div class="cols">
              <!-- Action column width -->
              <div
                [hidden]="
                  !searchResultMap.forms?.datagrid?.subsection2
                    ?.actionColumnWidth
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Action column width"
                  label="Action column width"
                  labelID="datagrid-action-column-width"
                  initialValue="40"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Cell horizontal padding -->
              <div
                [hidden]="
                  !searchResultMap.forms?.datagrid?.subsection2
                    ?.cellHorizontalPadding
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Cell horizontal padding"
                  label="Cell horizontal padding"
                  labelID="datagrid-cell-horizontal-padding"
                  initialValue="16"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
            </div>
          </article>
        </fieldset>

        <!-- File -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.file"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@File">File</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article
            style="--index: 1"
            [hidden]="!searchResultMap.forms?.file?.uploadIconSize"
          >
            <!-- Upload icon size -->
            <app-configurator-input-field
              i18n-label="@@Upload icon size"
              label="Upload icon size"
              labelID="file-upload-icon-size"
              initialValue="20"
              suffix="px"
            >
            </app-configurator-input-field>
          </article>
        </fieldset>

        <!-- Guide -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.guide"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Guide">Guide</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <!-- Fees and Documents -->
          <article
            style="--index: 1"
            [hidden]="!searchResultMap.forms?.guide?.feesDocs"
          >
            <header i18n="@@Fees and Documents">Fees and Documents</header>
            <div class="cols">
              <!-- Item separation -->
              <div
                [hidden]="
                  !searchResultMap.forms?.guide?.feesDocs?.itemSeparation
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Item separation"
                  label="Item separation"
                  labelID="guide-fees-docs-item-separation"
                  initialValue="14"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Text size -->
              <div
                [hidden]="
                  !searchResultMap.forms?.guide?.feesDocs?.totalTextSize
                "
              >
                <app-configurator-input-field
                  i18n-label="@@Total text size"
                  label="Total text size"
                  labelID="guide-fees-docs-panel-total-font-size"
                  initialValue="14"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Font weight -->
              <div
                [hidden]="
                  !searchResultMap.forms?.guide?.feesDocs?.totalFontWeight
                "
              >
                <app-configurator-select-field
                  i18n-label="@@Total font weight"
                  label="Total font weight"
                  labelID="guide-fees-docs-font-weight"
                  [defaultValue]="900"
                  [options]="{ type: 'font-weight' }"
                >
                </app-configurator-select-field>
              </div>
            </div>
          </article>
        </fieldset>

        <!-- Payment form -->
        <fieldset
          [ngClass]="{ 'section-open': defaultOpenSections }"
          [hidden]="!searchResultMap.forms?.payment"
        >
          <legend>
            <button
              type="button"
              class="legend-toggle"
              (click)="toggleClass($event, 'section-open')"
            >
              <span i18n="@@Payment form">Payment form</span>
              <i class="far fa-angle-down"></i>
            </button>
          </legend>

          <article style="--index: 1">
            <div class="cols auto">
              <!-- Fee totals font size -->
              <div
                [hidden]="!searchResultMap.forms?.payment?.feesTotalTextSize"
              >
                <app-configurator-input-field
                  i18n-label="@@Fees total text size"
                  label="Fees total text size"
                  labelID="payment-fees-total-font-size"
                  initialValue="18"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Fee separator line width -->
              <div
                [hidden]="!searchResultMap.forms?.payment?.feeSeparatorWidth"
              >
                <app-configurator-input-field
                  i18n-label="@@Fees separator width"
                  label="Fees separator width"
                  labelID="payment-fees-separator-line-width"
                  initialValue="1"
                  suffix="px"
                >
                </app-configurator-input-field>
              </div>
              <!-- Fee separator line color -->
              <div [hidden]="!searchResultMap.forms?.payment?.separatorColor">
                <app-configurator-color-field
                  i18n-label="@@Separator color"
                  label="Separator color"
                  labelID="payment-fees-separator-line-color"
                  initialColor="#E6E6E6"
                >
                </app-configurator-color-field>
              </div>
            </div>
          </article>
        </fieldset>
      </div>
    </section>
  </div>
  <div class="drawer-footer">
    <div class="btn-group dropup">
      <button type="button" class="drawer-btn green">
        <i class="fal fa-bookmark"></i
        ><ng-container i18n="@@Save for me">Save for me</ng-container>
      </button>
      <button
        type="button"
        class="drawer-btn green dropdown-toggle dropdown-toggle-split dots"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span class="sr-only">Toggle Dropdown</span>
      </button>
      <div class="dropdown-menu">
        <a i18n="@@Export" class="dropdown-item" href="#">Export</a>
        <a i18n="@@Import" class="dropdown-item" href="#">Import</a>
        <hr class="dropdown-divider" />
        <a i18n="@@Save as new theme" class="dropdown-item" href="#"
          >Save as new theme</a
        >
        <a i18n="@@Save for everyone" class="dropdown-item" href="#"
          >Save for everyone</a
        >
      </div>
    </div>
    <button class="drawer-btn gray secondary">
      <i class="fal fa-arrow-rotate-left"></i
      ><ng-container i18n="@@Undo">Undo</ng-container>
    </button>
    <button class="drawer-btn red secondary reset-changes">
      <i class="fal fa-arrow-rotate-right"></i
      ><ng-container i18n="@@Reset">Reset</ng-container>
    </button>
  </div>
</div>
